//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { ReportType } from './Enums';

export class PaymentReceiptReportInputItem extends ReportInputItem {
    EmailSubject: string | null = null;
    EmailBody: string | null = null;
    EmailRecipientParentID: string | null = null;
    EmailSenderTeacherID: string | null = null;
    EmailBccTeacher: boolean = false;
    ReceivableID: string | null = null;
    override readonly Type: ReportType = ReportType.PaymentReceipt;

    constructor(initializer?: Partial<Omit<PaymentReceiptReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "PaymentReceiptReportInputItem";
}
